export const flattenQuery = (params: Record<string, any>) => {
  const out: Record<string, any> = {};
  Object.entries(params).forEach(([k, v]) => {
    if (v == null || v === '' || (Array.isArray(v) && !v.length)) return;

    if (typeof v === 'object' && 'startDate' in v && 'endDate' in v) {
      out[`${k}_from`] = new Date((v as any).startDate).toISOString();
      out[`${k}_to`] = new Date((v as any).endDate).toISOString();
    } else {
      out[k] = Array.isArray(v) ? v.join(',') : v;
    }
  });
  return out;
};
